import { useCallback, useEffect, useState } from 'react';
// Remember the last conversation within this browser tab only.
const STORAGE_KEY = 'ts:assistant:lastChatId';
const CHANGE_EVENT = 'thousand-sunny:lastChatIdChange';
function read() {
    if (typeof window === 'undefined') return null;
    try {
        return window.sessionStorage.getItem(STORAGE_KEY);
    } catch  {
        return null;
    }
}
function write(id) {
    try {
        if (id) window.sessionStorage.setItem(STORAGE_KEY, id);
        else window.sessionStorage.removeItem(STORAGE_KEY);
    } catch  {
    // Storage unavailable (private mode, quota) — in-memory state still updates.
    }
    // Notify other hook instances within this tab.
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT));
}
export function useLastChatId() {
    const [lastChatId, setStateValue] = useState(()=>read());
    useEffect(()=>{
        function handle() {
            setStateValue(read());
        }
        window.addEventListener(CHANGE_EVENT, handle);
        return ()=>{
            window.removeEventListener(CHANGE_EVENT, handle);
        };
    }, []);
    const setLastChatId = useCallback((id)=>{
        if (!id) return;
        setStateValue(id);
        write(id);
    }, []);
    const clearLastChatId = useCallback(()=>{
        setStateValue(null);
        write(null);
    }, []);
    return {
        lastChatId,
        setLastChatId,
        clearLastChatId
    };
}
